import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "@/App.css";

import { I18nProvider } from "@/i18n/I18nProvider";
import { AppLayout } from "@/components/AppLayout";
import { getSettings } from "@/store/store";

import Onboarding from "@/pages/Onboarding";
import Today from "@/pages/Today";
import Result from "@/pages/Result";
import Dashboard from "@/pages/Dashboard";
import History from "@/pages/History";
import Reflection from "@/pages/Reflection";
import Settings from "@/pages/Settings";

import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import DeleteData from "@/pages/legal/DeleteData";
import AiNotice from "@/pages/legal/AiNotice";

import Premium from "@/pages/Premium";

/**
 * Root — redirects based on onboarding state on first paint.
 * Uses fresh localStorage read so it survives reloads.
 */
function Root() {
  const { onboardingCompleted } = getSettings();
  return <Navigate to={onboardingCompleted ? "/today" : "/onboarding"} replace />;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Root />} />
              <Route path="/onboarding" element={<Onboarding />} />

              <Route path="/today" element={<Today />} />
              <Route path="/result" element={<Result />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/history" element={<History />} />
              <Route path="/reflection" element={<Reflection />} />
              <Route path="/settings" element={<Settings />} />

              <Route path="/premium" element={<Premium />} />

              {/* Public legal routes — must render without onboarding/guard.
                  Required by Google Play (reviewer needs incognito access). */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/delete-account" element={<DeleteData />} />
              <Route path="/ai-notice" element={<AiNotice />} />

              {/* Aliases — normalize to the canonical public path */}
              <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
              <Route path="/terms-of-use" element={<Navigate to="/terms" replace />} />
              <Route path="/delete-data" element={<Navigate to="/delete-account" replace />} />

              {/* Backward compatibility — deep links using the old /legal/* paths */}
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/legal/terms" element={<Terms />} />
              <Route path="/legal/delete-data" element={<DeleteData />} />
              <Route path="/legal/ai-notice" element={<AiNotice />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
